export const hasLoaded = (ctr) => ctr.getAttribute('data-loaded') === '1';
export const hasAutoplay = (ctr) => ctr.getAttribute('data-autoplay') === '1';
export const isPaused = (ctr) => ctr.getAttribute('data-paused') === '1';
